<template>
    <div class="alert inline alert-info">
        <h4>Passwords must:</h4>
        <ul style="margin-left: 25px;">
            <li>Be at least 8 characters long</li>
            <li>Must have at least one uppercase and one lowercase letter</li>
            <li>Must have at least one number</li>
            <li>Must have at least one special character</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'PasswordRequirements',
    props: {
    }
}
</script>